// Convert backend `period` keys ("2026-W11", "2026-03", "2026-03-15") into
// a short human-readable label ("Mar 9", "Mar 2026", "Mar 15"). Used by the
// Insights / Tag-timeline charts so x-axis ticks are readable instead of the
// raw ISO-week token.
export function formatPeriodLabel(period) {
  if (!period) return "";
  const isoWeek = period.match(/^(\d{4})-W(\d{2})$/);
  if (isoWeek) {
    const year = parseInt(isoWeek[1], 10);
    const week = parseInt(isoWeek[2], 10);
    // ISO week 1 contains January 4. Walk back to its Monday, then forward
    // (week - 1) * 7 days to the target week's Monday.
    const jan4 = new Date(Date.UTC(year, 0, 4));
    const dow = jan4.getUTCDay() || 7;
    const week1Monday = new Date(jan4);
    week1Monday.setUTCDate(jan4.getUTCDate() - (dow - 1));
    const target = new Date(week1Monday);
    target.setUTCDate(week1Monday.getUTCDate() + (week - 1) * 7);
    return target.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      timeZone: "UTC",
    });
  }
  const month = period.match(/^(\d{4})-(\d{2})$/);
  if (month) {
    const d = new Date(Date.UTC(parseInt(month[1], 10), parseInt(month[2], 10) - 1, 1));
    return d.toLocaleDateString("en-US", { month: "short", year: "numeric", timeZone: "UTC" });
  }
  const day = period.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (day) {
    const d = new Date(Date.UTC(
      parseInt(day[1], 10),
      parseInt(day[2], 10) - 1,
      parseInt(day[3], 10),
    ));
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
  }
  return period;
}
